import { notification } from 'antd';
import { DURATION_TURN_OFF_DIALOG, LANGUAGES } from '../Constants';
import { Key, ReactNode } from 'react';

/**
 * ローカルストレージにデータの削除を行う
 *
 * @returns {void}
 */
export const clearStorage = async (): Promise<void> => {
    localStorage.removeItem('busData');
    localStorage.removeItem('busDataList');
    localStorage.removeItem('ticket.info.orderId');
    localStorage.removeItem('ticket.info.numberAdult');
    localStorage.removeItem('ticket.info.numberChild');
    localStorage.removeItem('webTicketConfig');
    localStorage.removeItem('LAST_LOGIN_TIME');
    localStorage.removeItem('AUTO_LOGOUT');
    deleteDataCache();
};

/**
 * キャッシュデータを削除する
 *
 * @returns {void}
 */
const deleteDataCache = (): void => {
    if ('caches' in window) {
        void caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
                void caches.delete(cacheName);
            });
        });
    }
};

/**
 * 表示するデフォルトフォントを変更する。
 * @param {string} fontFamily
 */
export const applyFontFamily = (fontFamily?: string) => {
    if (fontFamily) {
        document.documentElement.style.setProperty('--default-font-family', `${fontFamily}`);
    } else {
        document.documentElement.style.setProperty('--default-font-family', `NotoSans`);
    }
};
/**
 * 表示するデフォルトフォントを言語から変更する。
 * @param {string} language
 * @returns
 */
export const applyFontFromLanguage = (language: string) => {
    const languageData = LANGUAGES.find((item) => item.key === language);
    if (!languageData) {
        return;
    }
    applyFontFamily(languageData.fontFamily);
};

export const showNotificationDialog = (
    type: string = 'success',
    key: Key | undefined,
    title: ReactNode,
    content?: ReactNode,
) => {
    if (type === 'success') {
        notification.success({
            duration: DURATION_TURN_OFF_DIALOG,
            key: key,
            message: title,
            description: content,
        });
        return;
    }
    notification.error({
        duration: DURATION_TURN_OFF_DIALOG,
        key: key,
        message: title,
        description: content,
    });
};
